<template>
    <div class="payback-points row align-items-center">
        <span :class="logoClass">
            <IconSvg filepath="partners/Payback-logo.svg" class="payback-points__logo" />
        </span>
        <span class="col section-header text-nowrap mb-0">
            Basis°Punkte
            <span class="extra-points" v-if="showExtraPoints"><br/>Extra°Punkte</span>
        </span>
        <span class="col text-right">
            {{ paybackPoints }}
            <span class="extra-points" v-if="showExtraPoints"><br/>+{{ extraPoints }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'PaybackPoints',
    props: {
        amountToPay: {
            type: Number,
            required: true,
        },
        extraPoints: {
            type: Number,
            required: false,
        },
    },
    computed: {
        logoClass() {
            return this.extraPoints ? "col-auto col-100pct" : "col-auto";
        },
        showExtraPoints() {
            return this.extraPoints > 0;
        },
        paybackPoints() {
            return Math.floor(this.amountToPay / 200);
        },
    },
};
</script>

<style scoped lang="scss">
.payback-points {
    &__logo {
        width: 120px !important;
        height: 45px !important;
        margin-top: 11px;
    }

    .col {
        line-height: 24px;
    }
    .col-100pct {
        width: 100%;
    }

    .extra-points {
        color: #0f9d58;
    }
}
</style>
